export default __webpack_public_path__ + "static/media/ababazaminal.0b2b20b3.png";